import { createFeature, createReducer, on } from '@ngrx/store';
import { AccountManager, DefinitionCategory, Office, TechSupport, Faq, FaqCategory } from '@emi/shared/models';
import * as helpResourcesActions from './help-resources.actions';

export interface HelpResourcesState {
    offices: Office[];
    techSupport: TechSupport | undefined;
    isSendFeedbackSuccessful: boolean | undefined;
    accountManagers: AccountManager[];
    categoryDefinitions: DefinitionCategory | undefined;
    definitions: DefinitionCategory[];
    faqs: Array<Faq>;
    faqCategories: Array<FaqCategory>;
    isLoading: boolean;
}

export const helpResourcesFeatureKey = 'help-resources';

export const initialHelpResourcesState: HelpResourcesState = {
    offices: [],
    techSupport: undefined,
    isSendFeedbackSuccessful: undefined,
    accountManagers: [],
    categoryDefinitions: undefined,
    definitions: [],
    faqs: [],
    faqCategories: [],
    isLoading: false,
};

export const feature = createFeature({
    name: helpResourcesFeatureKey,
    reducer: createReducer(
        initialHelpResourcesState,
        on(helpResourcesActions.getContactUsOfficeSuccess, (state, { offices }) => {
            return {
                ...state,
                offices,
            };
        }),
        on(helpResourcesActions.getContactUsTechSupportSuccess, (state, { techSupport }) => {
            return {
                ...state,
                techSupport,
            };
        }),
        on(helpResourcesActions.sendContactUsFeedbackSuccess, (state) => {
            return {
                ...state,
                isSendFeedbackSuccessful: true,
            };
        }),
        on(helpResourcesActions.sendContactUsFeedbackFailure, (state) => {
            return {
                ...state,
                isSendFeedbackSuccessful: false,
            };
        }),
        on(helpResourcesActions.getContactUsAccountManagerSuccess, (state, { accountManagers }) => {
            return {
                ...state,
                accountManagers,
            };
        }),
        on(helpResourcesActions.resetFeedbackResult, (state) => {
            return {
                ...state,
                isSendFeedbackSuccessful: undefined,
            };
        }),
        on(helpResourcesActions.getCategoryDefinitionsSuccess, (state, { categoryDefinitions }) => {
            return {
                ...state,
                categoryDefinitions,
                isLoading: false,
            };
        }),
        on(helpResourcesActions.getCategoryDefinitionsFailure, (state) => {
            return {
                ...state,
                isLoading: false,
            };
        }),
        on(helpResourcesActions.setIsLoading, (state) => {
            return {
                ...state,
                isLoading: true,
            };
        }),
        on(helpResourcesActions.getDefinitionsSuccess, (state, { definitions }) => {
            return {
                ...state,
                definitions: definitions,
                isLoading: false,
            };
        }),
        on(helpResourcesActions.getDefinitionsFailure, (state) => {
            return {
                ...state,
                isLoading: false,
            };
        }),
        on(helpResourcesActions.getFaqCategoriesSuccess, (state, { faqCategories }) => {
            return {
                ...state,
                isLoading: false,
                faqCategories: faqCategories,
                error: null,
            };
        }),
        on(helpResourcesActions.getFaqCategoriesFailure, (state) => {
            return {
                ...state,
                isLoading: false,
            };
        }),
        on(helpResourcesActions.getFaqCategoriesFaqsSuccess, (state, { faqs }) => {
            return {
                ...state,
                isLoading: false,
                faqs: faqs,
                error: null,
            };
        }),
        on(helpResourcesActions.getFaqCategoriesFaqsFailure, (state) => {
            return {
                ...state,
                isLoading: false,
            };
        })
    ),
});
